import request from '@/utils/request'
import requestJson from '@/utils/requestJson'

// 客户报表
export function getcustomerlist(data) {
  return request({
    url: '/admin/Report_list/getcustomerlist',
    method: 'post',
    data
  })
}

// 采购报表
export function getbuylist(data) {
  return request({
    url: '/admin/Report_list/getbuylist',
    method: 'post',
    data
  })
}
//外卖报表
export function gettakeoutlist(data) {
  return request({
    url: '/admin/Report_list/gettakeout',
    method: 'post',
    data
  })
}
//外卖详情报表
export function getdetailList(data) {
  return request({
  url: '/admin/Report_list/gettakeoutdetailList',
  method: 'post',
  data
  })
}
// 销售报表
export function getsalelist(data) {
  return request({
    url: '/admin/Report_list/getsalelist',
    method: 'post',
    data
  })
}
// 库存报表
export function getinventorylist(data) {
  return request({
    url: '/admin/Report_list/getinventorylist',
    method: 'post',
    data
  })
}

// 刷单报表
export function getBrushAnalysis(data) {
  return request({
    url: '/admin/Brush_analysis/getList',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/report.js